<template>
  <v-container class="px-12">
    <v-row>
      <v-col cols="12" lg="6" offset-lg="3">
        <BaseTitle class="mt-16 mb-6">
          {{ $t('Password change title')}}
        </BaseTitle>
        <form @submit.prevent="submit">
          <v-text-field
            v-model="password"
            :label="$t('Password')"
            :type="showPassword ? 'text' : 'password'"
            required
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />
          <v-btn color="primary" block bottom type="submit" class="mb-8">
            Changer mon mot de passe
          </v-btn>
          <div class="text-center">
            <router-link to="/connexion">
              {{ $t('Sign in')}}
            </router-link>
          </div>
        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapMutations } from 'vuex';
import { get } from 'lodash';
import BaseTitle from '@/components/BaseTitle.vue';

export default {
  name: 'PasswordChange',
  components: {
    BaseTitle,
  },
  created() {
    this.token = this.$route.query.token;
  },
  data() {
    return {
      showPassword: false,
      token: undefined,
    };
  },
  methods: {
    ...mapActions('authentication', ['resetPassword']),
    ...mapMutations(['setAlert']),
    submit() {
      this.resetPassword({ token: this.token }).then(() => {
        this.$router.push('/connexion');
        this.setAlert({
          text: 'Votre mot de passe a été modifié, vous pouvez vous connecter.',
          color: 'success',
          show: true,
        });
      }).catch((error) => {
        console.log(error.response);
        if (get(error.response, 'data.errors.password')) {
          this.setAlert({
            text: 'Votre mot de passe doit faire au moins 6 caractères',
            color: 'error',
            show: true,
          });
        } else {
          this.setAlert({
            text: 'Une erreur s\'est produite.',
            color: 'error',
            show: true,
          });
        }
      });
    },
  },
  computed: mapFields('authentication', ['form.password']),
};
</script>
